<app-modal [header]="'Motivo de remoção'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="displayModal = false; this.onCancelModal.emit();">

  <div>

    <div class="text-xs mb-10 space-y-2">

      <p>Valide esta ocorrência e, caso não sejam encontrados erros ou infrações às boas práticas e políticas do
        AngolaEncontra, clique no botão abaixo para retornar a ocorrência ao estado 'Ativo'.</p>

      <p class="text-amber-800 py-4">{{ event.outcomeMessage }}</p>

    </div>

    <hr>
    <div class="flex justify-end mt-4">
      <app-ae-button variant="primary" label="Restaurar ocorrência" [loading]="isLoading"
                (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
    </div>
  </div>

</app-modal>
